import { render } from "./testimonyComponent.vue?vue&type=template&id=7f961558"
import script from "./testimonyComponent.vue?vue&type=script&lang=js"
export * from "./testimonyComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__